import React 		from 'react'
import classnames 	from 'classnames'
import Helmet 		from 'react-helmet'
import {
	connect
} from 'react-redux'
import {
	CSSTransition
} from 'react-transition-group'

import Footer 		from '../footer'

import {
	setHeaderColour,
	updateHeaderColour
} from '../../redux/actions'

class PageLayout extends React.Component {
	constructor(props) {
		super(props)
	}

	componentDidMount(){
		const {
			dispatch,
			headerColour,
			location,
			bgColour
		} = this.props

		//dispatch(updateHeaderColour(bgColour ? bgColour : null))

		dispatch(setHeaderColour(location.pathname, headerColour))
		//dispatch(setHeaderColour(headerColour))
	}

	render() {
		const {
			children,
			bgColour,
			headerHeight,
			screenSize,
			siteTitle,
			siteDescription,
			skipFooter,
			ignorePaddingBottom,
			pagesSubMenus,
			location
		} = this.props

		const pageHasSubMenu = !!pagesSubMenus[location.pathname]
		let _headerHeight = headerHeight
		if(pageHasSubMenu){
			_headerHeight += 60
		}

		const _title = siteTitle ? siteTitle : 'Endomag'
		const _description = siteDescription ? siteDescription : 'We believe everyone deserves a better standard of cancer care. Our technologies have been designed to revolutionise cancer care by helping women with breast cancer benefit from improved surgery.'

		return <div
			className={ classnames('pageLayout', {
				[`bg--${ bgColour }`]: !!bgColour
			}) }
			>
			<Helmet>
				<title>{ _title }</title>
				<meta name="description" content={ _description } />
				<meta property="og:title" content={ _title } />
				<meta property="og:description" content={ _description } />
			</Helmet>

			<div className="pageLayout-content"
				style={{
					paddingTop: _headerHeight,
					minHeight: screenSize.height
				}}>
				{ children }
			</div>

			{ !skipFooter ? <Footer /> : null }
		</div>
	}
}

const mapStateToProps = (state) => {
	const {
		pages,
		ui
	} = state

    return {
    	headerHeight: ui.headerHeight,
		screenSize: ui.screenSize,
		pagesSubMenus: pages.hasSubMenu
    }
}

export default connect(mapStateToProps, null)(PageLayout)